<template>
  <div class="app-f-header">
    <div class="app-f-header-logo">
      <app-title homeUrl="/"></app-title>
      <el-button
        :type="routerName === 'template-public' ? 'primary' : 'info'"
        size="small"
        round
        class="c-font-14"
        @click="handlePubClick"
        >模板广场</el-button
      >
      <app-project class="c-f-right"></app-project>
    </div>
    <!-- <app-menu class=""></app-menu> -->
    <div class="app-f-header-oparate">
      <el-button
        v-if="canUpload"
        type="info"
        size="small"
        icon="el-icon-plus"
        round
        class="c-font-14"
        @click="handleOpenModal"
        >上传模板</el-button
      >
      <app-logout></app-logout>
    </div>
    <tpl-upload-modal v-model="uploadVisible" @success="handleCloseModal"/>
  </div>
</template>
<script>
import appTitle from './app-title'
import appLogout from './app-logout'
import appProject from './app-project'
import TplUploadModal from './tpl-upload-modal.vue'
import { mapGetters } from 'vuex'
import util from '@/util.js'
export default {
  components: {
    TplUploadModal,
    // appMenu,
    appTitle,
    appLogout,
    appProject
  },
  data () {
    return {
      routerName: this.$route.name,
      uploadVisible: false
    }
  },
  computed: {
    ...mapGetters({
      canUpload: 'app/canUpload',
      projectId: 'app/projectId'
    })
  },
  methods: {
    handlePubClick () {
      this.$router.push({ name: 'template-public' })
    },
    handleOpenModal () {
      this.uploadVisible = true
    },
    handleCloseModal (v) {
      console.log(this.routerName)
      if (this.routerName === 'template' && v === this.projectId) {
        return this.eventBus.$emit('refreshTplData')
      }
      this.uploadVisible = false
      util.setStorageProjectId(v)
      this.$store.commit('app/set_active_project', v)
      let pageName = this.$route.meta.userActionKey
      this.saveUserAction(pageName, this.ActionType.project.switch.key)
      if (v) {
        let user = this.$store.state.app.loginUser
        if (user.role) {
          this.$store.commit('app/set_active_project_role', user.role)
        } else {
          let projects = this.$store.state.app.loginUser.projectRoles
          let projectRole = projects.find(item => {
            return item.projectId === v
          })
          let role = projectRole ? projectRole.role : ''
          this.$store.commit('app/set_active_project_role', role)
        }
        if (this.$route.path.indexOf('admin') > -1) {
          this.$router.push({ name: 'template', query: { projectId: v } })
        } else {
          this.$router.push({
            name: 'template',
            query: Object.assign({}, this.$route.query, { projectId: v })
          })
        }
      }
    }
  }
}
</script>
<style lang="scss">
$appHeaderHeight: 48px;
.app-f-header {
  display: flex;
  position: relative;
  padding: 0 20px;
  width: 100%;
  height: $appHeaderHeight;
  line-height: $appHeaderHeight;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  color: #666;
  box-sizing: border-box;
  // border-bottom: 1px solid #ececec;
  .login-photo,
  .login-name {
    margin-right: 10px;
  }
  .app-f-header-logo {
    display: flex;
    flex-direction: row;
    align-items: center;
    line-height: $appHeaderHeight;
  }
  .app-f-header-oparate {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .c-font-14 {
    padding: 8px 15px;
  }
}
</style>
